import { EventsFilter } from '../components/interfaces';
import {LIMIT_STEP} from '../constants';
import filters from "../redux/reducers/filters";
import moment from 'moment-timezone';

const tallinnTimezone = 'Europe/Tallinn'; 

type FormatOptions = {
    weekday?: string;
    year?: string;
    month?: string;
    day?: string;
}
export const compareFilters = (first: EventsFilter, second: EventsFilter): boolean => {
    return Object.entries(first).sort().toString() === Object.entries(second).sort().toString()
}

export const formatTime = (timestamp: number) => {
    return moment(timestamp*1000).tz(tallinnTimezone).format('HH:mm');
}

export const formatDate = (timestamp: number, format=''): string => {
    const newDate = new Date(timestamp*1000);
    const options = formatDateOptions(format)
    let lang = 'et';
    if (format === 'dd.mm.yyyy') {
        lang = 'ru';
    }
    // @ts-ignore
    return newDate.toLocaleDateString(lang, options)
    
}

const formatDateOptions = (format: string): FormatOptions => {
    switch (format) {
        case 'dd.mm.yyyy':
        case 'd.m.yyyy':
            return { year: 'numeric',month: 'numeric', day: 'numeric' };
        case 'd.M':
            return { month: 'long', day: 'numeric' };
        case 'w.d.M':
            return { weekday: 'short', month: 'long', day: 'numeric' };
        default:
            return { year: 'numeric', weekday: 'short', month: 'long', day: 'numeric' };
    }
}

const mapOptionsToFormat = (inputOptions: Record<string, string>): string => {

    const formatMapping = {
        year: 'YYYY',
        month: 'M',
        day: 'D',
        hour: 'H',
        minute: 'm',
        second: 's',
        weekday: 'd'
      };
      
      // Example usage
      //const options = { year: 'numeric', month: 'long', day: 'numeric' };
      
      const formatString = Object.keys(inputOptions)
      //@ts-ignore
        .map(option => formatMapping[option])
        .join(' ');

        return formatString;
}

export const mediaQuery = (match: string) => {
    return window.matchMedia(match).matches;
}


export const convertChars = (str: string): string => {
    // apostroph
    const result = str.replace(/&#039;&#039;/g,'"');
    // more to be added
    return result;
}

export const transliterator = (str: string): string => {
    // prettier-ignore
    const DEFAULT_APPROXIMATIONS: any = {
        'À': 'A',   'Á': 'A',   'Â': 'A',   'Ã': 'A',   'Ä': 'A',   'Å': 'A',   'Æ': 'AE',
        'Ç': 'C',   'È': 'E',   'É': 'E',   'Ê': 'E',   'Ë': 'E',   'Ì': 'I',   'Í': 'I',
        'Î': 'I',   'Ï': 'I',   'Ð': 'D',   'Ñ': 'N',   'Ò': 'O',   'Ó': 'O',   'Ô': 'O',
        'Õ': 'O',   'Ö': 'O',   '×': 'x',   'Ø': 'O',   'Ù': 'U',   'Ú': 'U',   'Û': 'U',
        'Ü': 'U',   'Ý': 'Y',   'Þ': 'Th',  'ß': 'ss',  'à': 'a',   'á': 'a',   'â': 'a',
        'ã': 'a',   'ä': 'a',   'å': 'a',   'æ': 'ae',  'ç': 'c',   'è': 'e',   'é': 'e',
        'ê': 'e',   'ë': 'e',   'ì': 'i',   'í': 'i',   'î': 'i',   'ï': 'i',   'ð': 'd',
        'ñ': 'n',   'ò': 'o',   'ó': 'o',   'ô': 'o',   'õ': 'o',   'ö': 'o',   'ø': 'o',
        'ù': 'u',   'ú': 'u',   'û': 'u',   'ü': 'u',   'ý': 'y',   'þ': 'th',  'ÿ': 'y',
        'Ā': 'A',   'ā': 'a',   'Ă': 'A',   'ă': 'a',   'Ą': 'A',   'ą': 'a',   'Ć': 'C',
        'ć': 'c',   'Ĉ': 'C',   'ĉ': 'c',   'Ċ': 'C',   'ċ': 'c',   'Č': 'C',   'č': 'c',
        'Ď': 'D',   'ď': 'd',   'Đ': 'D',   'đ': 'd',   'Ē': 'E',   'ē': 'e',   'Ĕ': 'E',
        'ĕ': 'e',   'Ė': 'E',   'ė': 'e',   'Ę': 'E',   'ę': 'e',   'Ě': 'E',   'ě': 'e',
        'Ĝ': 'G',   'ĝ': 'g',   'Ğ': 'G',   'ğ': 'g',   'Ġ': 'G',   'ġ': 'g',   'Ģ': 'G',
        'ģ': 'g',   'Ĥ': 'H',   'ĥ': 'h',   'Ħ': 'H',   'ħ': 'h',   'Ĩ': 'I',   'ĩ': 'i',
        'Ī': 'I',   'ī': 'i',   'Ĭ': 'I',   'ĭ': 'i',   'Į': 'I',   'į': 'i',   'İ': 'I',
        'ı': 'i',   'Ĳ': 'IJ',  'ĳ': 'ij',  'Ĵ': 'J',   'ĵ': 'j',   'Ķ': 'K',   'ķ': 'k',
        'ĸ': 'k',   'Ĺ': 'L',   'ĺ': 'l',   'Ļ': 'L',   'ļ': 'l',   'Ľ': 'L',   'ľ': 'l',
        'Ŀ': 'L',   'ŀ': 'l',   'Ł': 'L',   'ł': 'l',   'Ń': 'N',   'ń': 'n',   'Ņ': 'N',
        'ņ': 'n',   'Ň': 'N',   'ň': 'n',   'ŉ': '\'n', 'Ŋ': 'NG',  'ŋ': 'ng',
        'Ō': 'O',   'ō': 'o',   'Ŏ': 'O',   'ŏ': 'o',   'Ő': 'O',   'ő': 'o',   'Œ': 'OE',
        'œ': 'oe',  'Ŕ': 'R',   'ŕ': 'r',   'Ŗ': 'R',   'ŗ': 'r',   'Ř': 'R',   'ř': 'r',
        'Ś': 'S',   'ś': 's',   'Ŝ': 'S',   'ŝ': 's',   'Ş': 'S',   'ş': 's',   'Š': 'S',
        'š': 's',   'Ţ': 'T',   'ţ': 't',   'Ť': 'T',   'ť': 't',   'Ŧ': 'T',   'ŧ': 't',
        'Ũ': 'U',   'ũ': 'u',   'Ū': 'U',   'ū': 'u',   'Ŭ': 'U',   'ŭ': 'u',   'Ů': 'U',
        'ů': 'u',   'Ű': 'U',   'ű': 'u',   'Ų': 'U',   'ų': 'u',   'Ŵ': 'W',   'ŵ': 'w',
        'Ŷ': 'Y',   'ŷ': 'y',   'Ÿ': 'Y',   'Ź': 'Z',   'ź': 'z',   'Ż': 'Z',   'ż': 'z',
        'Ž': 'Z',   'ž': 'z',
        'А': 'A',   'Б': 'B',   'В': 'V',   'Г': 'G',   'Д': 'D',   'Е': 'E',   'Ё': 'E',
        'Ж': 'ZH',  'З': 'Z',   'И': 'I',   'Й': 'J',   'К': 'K',   'Л': 'L',   'М': 'M',
        'Н': 'N',   'О': 'O',   'П': 'P',   'Р': 'R',   'С': 'S',   'Т': 'T',   'У': 'U',
        'Ф': 'F',   'Х': 'KH',  'Ц': 'C',   'Ч': 'CH',  'Ш': 'SH',  'Щ': 'SHCH',
        'Ъ': '',    'Ы': 'Y',   'Ь': '',    'Э': 'E',   'Ю': 'YU',  'Я': 'YA',
        'а': 'a',   'б': 'b',   'в': 'v',   'г': 'g',   'д': 'd',   'е': 'e',   'ё': 'e',
        'ж': 'zh',  'з': 'z',   'и': 'i',   'й': 'j',   'к': 'k',   'л': 'l',   'м': 'm',
        'н': 'n',   'о': 'o',   'п': 'p',   'р': 'r',   'с': 's',   'т': 't',   'у': 'u',
        'ф': 'f',   'х': 'kh',  'ц': 'c',   'ч': 'ch',  'ш': 'sh',  'щ': 'shch',
        'ъ': '',    'ы': 'y',   'ь': '',    'э': 'e',   'ю': 'yu',  'я': 'ya'
    };

    return str.replace(
        /[^\u0000-\u007f]/g,
        c => DEFAULT_APPROXIMATIONS[c] || '?'
    ).toLowerCase().replace(/\s+/,'_' );
}


export const getEmptyFilters = (): EventsFilter => {
    return {
        date: null,
        kind: null,
        where: null,
        start: 0,
        limit: LIMIT_STEP,
    }
}

export const isFiltersEmpty = (filter: EventsFilter) : boolean => {
    const { kind, where, date, keyword } = filter
    return !kind && !where && !date && !keyword
}
